import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { InputControlBase } from './../forms/input-control.base';

@Component({
    selector: 'app-numeric-box',
    templateUrl: './numeric-box.component.html',
    styleUrls: ['./numeric-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumericBoxComponent extends InputControlBase {
  constructor() {
    super();
  }

  @Input() decimals = 2;
  private _mask: RegExp;

  caption: string;
  ngOnInit() {
    super.ngOnInit();
    this.caption = this.control.caption;

    let regexStr = '^\\d{0,18}';
    if (this.decimals === 0) regexStr += '$';
    else regexStr += '([,\\.]\\d{1,' + this.decimals + '})?$';
    this._mask = new RegExp(regexStr);
  }

  onInput(value: string) {
    let newValue = this._mask.exec(value);
    this.control.setValue(newValue ? parseFloat(newValue[0].replace(',', '.').replace(' ', '')) : null);
    this.control.setValue(newValue ? newValue[0] : null);
  }
}
